<a (click)="openDialog()" class="cesium-credit-expand-link" >Disclaimer</a>
